import React from 'react'
import { Loader } from 'semantic-ui-react'
import Router from './navigation/router'
import Firebase from './config/Firebase'
import { store } from './redux'
import { Action } from './redux/actions/types'

class App extends React.Component {

      constructor(props) {
            super(props);
            this.state = {
                  authUser: {},
                  //storedUser: {},
                  isAuthReady: false,
                  //isStoredUserready: false
            }
            //this.getLocalStorage = this.getLocalStorage.bind(this)
      }

      componentDidMount() {
            Firebase.auth().onAuthStateChanged(authUser => {
                  //console.log("on auth change: ", authUser)
                  authUser
                        ? this.setState({ authUser })
                        : this.setState({ authUser: null })
                  this.setState({ isAuthReady: true })
            })
            //this.getLocalStorage()
      }

      // getLocalStorage() {
      //       let retrievedState
      //       try {
      //             retrievedState = localStorage.getItem('plant-hospital')
      //             if (retrievedState === null) {
      //                   retrievedState = {}
      //             }
      //             retrievedState = JSON.parse(retrievedState)
      //             console.log('state retrieved : ', retrievedState)
      //             this.setState({ storedUser: retrievedState, isStoredUserready: true })
      //       } catch (err) {
      //             retrievedState = {}
      //             this.setState({ storedUser: retrievedState, isStoredUserready: true })
      //       }

      // }

      render() {
            const { isAuthReady, authUser } = this.state
            if (isAuthReady) {
                  store.dispatch({ type: Action.USER_LOGGED_IN, payload: { session: authUser, data: {} } })
                  return (
                        <Router authUser={this.state.authUser} />
                  )
            } else {
                  return <Loader />
            }
      }
}


export default App
